import { render, staticRenderFns } from "./password-expired-form.vue?vue&type=template&id=fd7d92d0&scoped=true&"
import script from "./password-expired-form.vue?vue&type=script&lang=js&"
export * from "./password-expired-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7d92d0",
  null
  
)

export default component.exports